import { render, staticRenderFns } from "./RestoreDatabase.vue?vue&type=template&id=4c83f3e6"
import script from "./RestoreDatabase.vue?vue&type=script&lang=js"
export * from "./RestoreDatabase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports